export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro?: string
  bulletsIntro?: string
  bullets?: string[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  systemLabel?: string
  system?: string
  result?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Fire Service Instructor Lesson Planning System',
    subtitle: 'Build Structured Firefighter Training Sessions Faster',
    intro:
      'A professional planning resource created to help instructors organize training sessions without starting from a blank page.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Lesson planning frameworks',
      'Training objectives',
      'Session structures',
      'Instructor preparation',
      'Equipment planning',
      'Teaching sequences',
      'Student briefing templates',
      'Observation planning',
      'Common-error analysis',
      'Knowledge checks',
      'Assessment planning',
      'Reusable lesson templates',
    ],
    secondaryBulletsIntro: 'Includes formats for:',
    secondaryBullets: [
      '20-MINUTE TRAINING',
      '30-MINUTE TRAINING',
      '45-MINUTE TRAINING',
      '60-MINUTE TRAINING',
      '90-MINUTE TRAINING',
    ],
    result: 'Prepare more organized training sessions with less repetitive planning work.',
  },
  {
    id: '02',
    title: 'Firefighter Scenario & Decision-Making Library',
    subtitle: 'Ready-to-Use Training Scenarios for Classroom Discussion & Instructor-Led Practice',
    intro:
      'A structured collection of firefighter training scenarios created to encourage analysis, discussion and decision-making.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Firefighter readiness scenarios',
      'Equipment awareness',
      'Hose operations',
      'Fireground communication',
      'Building access',
      'Search and rescue',
      'Structural fire conditions',
      'Vehicle incidents',
      'Hazard recognition',
      'Team coordination',
      'Accountability',
      'Changing emergency conditions',
      'Instructor discussion questions',
      'Scenario updates',
      'Debriefing points',
    ],
    result:
      'Introduce more variety and practical discussion into your training without developing every scenario independently.',
  },
  {
    id: '03',
    title: 'Firefighter Assessment & Progress Tracking Handbook',
    subtitle: 'Evaluate Knowledge, Communication, Decision-Making & Training Development',
    intro:
      'A practical instructor resource for observing student performance, identifying learning gaps and documenting development.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Individual trainee assessments',
      'Team assessments',
      'Training observation records',
      'Communication evaluation',
      'Knowledge checks',
      'Decision-making criteria',
      'Skill gap identification',
      'Common-error tracking',
      'Progress monitoring',
      'Improvement plans',
      'Reassessment records',
      'Instructor feedback templates',
    ],
    result:
      'Evaluate student development with greater consistency and make future training objectives easier to identify.',
  },
  {
    id: '04',
    title: 'Fire Service Instructor Question Bank',
    subtitle: '300+ Questions for Reviews, Discussions, Knowledge Checks & Instructor-Led Training',
    intro:
      'A complete training question resource organized around the main areas of firefighter education.',
    bulletsIntro: 'Includes questions covering:',
    bullets: [
      'Firefighter foundations',
      'PPE and equipment',
      'SCBA awareness',
      'Fire service tools',
      'Hose systems',
      'Water supply',
      'Ladders',
      'Forcible-entry awareness',
      'Ventilation concepts',
      'Building construction awareness',
      'Search and rescue',
      'Structural fire operations',
      'Vehicle incidents',
      'Hazardous-material awareness',
      'Communication',
      'Accountability',
      'Safety',
      'Decision-making',
    ],
    secondaryBulletsIntro: 'Organized into:',
    secondaryBullets: ['FOUNDATION', 'INTERMEDIATE', 'ADVANCED'],
    result:
      'Have a large collection of instructor questions available to reinforce knowledge, stimulate classroom discussions and check understanding.',
  },
  {
    id: '05',
    title: 'Fire Service Debriefing & After-Action Review Manual',
    subtitle: 'Turn Every Drill & Scenario Into Better Future Performance',
    intro:
      'A structured resource that helps instructors review training sessions, identify improvement opportunities and turn observations into actionable development goals.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Quick training debriefs',
      'Structured after-action reviews',
      'Individual performance discussions',
      'Team performance reviews',
      'Communication analysis',
      'Decision-making discussions',
      'Common-error reviews',
      'Instructor feedback',
      'Lessons learned',
      'Improvement planning',
      'Corrective action records',
      'Next-session priorities',
    ],
    result: 'Make every training review more structured, specific and useful for future instruction.',
  },
]
